import React from "react";
import '../style/topbar.css';
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const TopBar = () => {
  return (
    <div className="topbar-container">
      <div className="topbar-left">
        <FaEnvelope className="topbar-icon" />
        <a
          href="mailto:laxmishilaj@gmail.com"
          className="topbar-link"
        >
          laxmishilaj@gmail.com
        </a>
        <span className="topbar-divider">|</span>

        <FaPhoneAlt className="topbar-phone-icon" />
        <a href="tel:+918480801010">
          <span className="topbar-text">Emergency: +91-84808 01010</span>
        </a>
      </div>

      {/* <div className="topbar-right">
        <FaLock className="topbar-lock-icon" />
        <a href="/admin-login" className="topbar-link">
          Admin Login
        </a>
      </div> */}
    </div>
  );
};

export default TopBar;
